import { render, staticRenderFns } from "./ZikiFooter.vue?vue&type=template&id=476f17bc&scoped=true"
import script from "./ZikiFooter.vue?vue&type=script&lang=js"
export * from "./ZikiFooter.vue?vue&type=script&lang=js"
import style0 from "./ZikiFooter.vue?vue&type=style&index=0&id=476f17bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f17bc",
  null
  
)

export default component.exports